module.exports = __webpack_public_path__ + "static/media/ministerior-educacion.204e5fa1.png";